import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex } from 'components/ui';
import { colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import resourceWrapper from 'utils/framework/resourceWrapper';
import CartLayoutEN from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_en_US';
import CartLayoutFR from 'components/RwdBasket/Carts/CartLayout/locales/CartLayout_fr_CA';

function FinalSaleMessage() {
    const getText = resourceWrapper(localeUtils.getLocalisedDataFromResource(CartLayoutEN, CartLayoutFR));

    return (
        <Flex
            fontSize={'sm'}
            marginTop={3}
            color={colors.red}
            children={getText('finalSale', true)}
        />
    );
}

export default wrapFunctionalComponent(FinalSaleMessage, 'FinalSaleMessage');
